<mat-expansion-panel [togglePosition]="'before'">
    <mat-expansion-panel-header>
    <mat-panel-title>
        Additional Employer Labour Condition Statement-H-1b Employer Only
    </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="p-4">
    <!-- Radio button -->
    <form [formGroup]="lcaAdlEmplStatH1BOnly">

        <div class="row my-3">            
            <div class="col-md-12 d-flex justify-content-end" *ngIf="isDuplicateLCA">
                <button class="clear-data-button" (click)="clearData()">
                    <i class="fa fa-repeat"></i> Clear Data
                 </button>
            </div>
        </div>
    
 <div class="col-6 mt-1 pl-3">                
    <label class="control-lbl required mt-2 label-cls">At The Time of filling LCA, is the Employer H-1B is dependent ? </label>
    <div class="row pt-2">
        <mat-radio-group  aria-label="Select an option" 
        name="isEmprH1bDependent" 
        formControlName="isEmprH1bDependent">
         <mat-radio-button [value]="true">Yes</mat-radio-button>
            <mat-radio-button [value]="false">No </mat-radio-button>
        </mat-radio-group>
    </div>
    
  </div>
  
  
  <!-- Radio button -->

   <div class="col-6 mt-1 pl-3">
                
    <label class="control-lbl required mt-2 label-cls">At The Time of filling LCA, is the Employer willful violator ? </label>
    <div class="row pt-2">
        <mat-radio-group  aria-label="Select an option" 
        name="isEmprWillfulViolator" 
        formControlName="isEmprWillfulViolator"> 
            <mat-radio-button [value]="true">Yes</mat-radio-button>
            <mat-radio-button [value]="false">No </mat-radio-button>
        </mat-radio-group>
    </div>
    
  </div>
  
  
  <!-- Radio button -->
   

   <div class="col-12 mt-1 pl-3">             
    <label class="control-lbl required mt-2 label-cls">Is the Employer to use this application only to support H-1B
        petition or extension of status for exempt H1-B nonimmigrant worker ? </label>
    <div class="row pt-2">
        <mat-radio-group  aria-label="Select an option" 
        name="isEmprForExmptH1bWrkr" 
        formControlName="isEmprForExmptH1bWrkr">    
                <mat-radio-button [value]="true">Yes</mat-radio-button>
            <mat-radio-button [value]="false">No </mat-radio-button>
        </mat-radio-group>
    </div>
    
  </div>
  
  
  <!-- Radio button -->

  <div class="col-12 mt-1 pl-3">
                
    <label class="control-lbl required mt-2 label-cls">If "yes" is marked in above question, identity the statutory basis exemption of the H-1B nonimmigrants worker associated with lca ? </label>
    <div class="row pt-2">
        <mat-radio-group  aria-label="Select an option" 
            name="statBasisForExmptId" 
            formControlName="statBasisForExmptId">
            <mat-radio-button [value]= "'HIANNUALSAL'">$60000 or higher annual wage</mat-radio-button>
            <mat-radio-button [value]="'MSORHIDEGR'">Master Degrees' or higher in related speciality </mat-radio-button>
            <mat-radio-button [value]= "'BOTH'">both </mat-radio-button>
            
        </mat-radio-group>
    </div>
    
  </div>
  
  
  <!-- Radio button -->
  <div class="col-12 mt-1 pl-3">
                
    <label class="control-lbl required mt-2 label-cls">Indicate whether a completed Appendix A is attached to this LCA
        Covering any H-1B for nonimmigrant worker for whom statutory exemption will be based  ONLY on attainment of Master's Degree or higher in related speciality ? </label>
    <div class="row pt-2">
        <mat-radio-group  aria-label="Select an option" 
        name="isApndxInclWrkrExmptOnHiDegr" 
        formControlName="isApndxInclWrkrExmptOnHiDegr">   
                 <mat-radio-button [value]=1>Yes</mat-radio-button>
            <mat-radio-button [value]=0>No </mat-radio-button>
            <mat-radio-button [value]=2>Not Applicable </mat-radio-button>

        </mat-radio-group>
    </div>
    
  </div>
  </form>
  
  <!-- Radio button -->
</div>

<!-- Confirm Reset Modal -->
<p-confirmDialog id="confirm-reset-modal" [style]="{width: '35vw'}"></p-confirmDialog>

</mat-expansion-panel>